"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const ChevronLeftLarge = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M6.621 11.9l8.307-8.307a.75.75 0 1 0-1.06-1.06l-8.836 8.834a.749.749 0 0 0-.006 1.059l.006.006 8.837 8.837a.745.745 0 0 0 1.06 0 .748.748 0 0 0 0-1.061l-8.308-8.309z", children: " " })
] });
var ChevronLeftLarge_default = ChevronLeftLarge;
export {
  ChevronLeftLarge_default as default
};
